import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { LoaderMi, SelectMi, Option, Bouton, Row, Col } from '@design-system-etat/dsfr-react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI, deleteAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from '../../../store/usagerReducer';
import {
    API_GET_NOMBRE_NOTIFICATIONS,
    CONTEXT_GET_NOMBRE_NOTIFICATIONS,
    API_GET_NOTIFICATIONS,
    CONTEXT_GET_NOTIFICATIONS,
    API_DELETE_NOTIFICATION,
    CONTEXT_DELETE_NOTIFICATION,
    API_DELETE_ALL_NOTIFICATIONS,
    CONTEXT_DELETE_ALL_NOTIFICATIONS,
} from '../../../constants/apiUrls.constants';
import AfficherNotificationsDynamique from './components/AfficherNotificationsDynamique';
import {
    DATA_NOTIFICATION_SELECT_FILTRE,
    DATA_NOTIFICATION_SELECT_TRI_DATE,
} from './constants/notifications.constants';

const RechercherNotifications = ({
    getApi,
    deleteApi,
    reinitialiseApi,
    isLoading,
    dataNotifications,
}) => {
    const { register, getValues, watch } = useForm({
        defaultValues: {
            TrierParDate: 'antechronologique',
            FiltrerParTypeNotifications: 'aucun',
        },
    });

    const [donneesNotifications, setDonneesNotifications] = useState([]);

    const recupererDernierIdNotifications = () => {
        const lastIndex =
            donneesNotifications && donneesNotifications.length > 0
                ? donneesNotifications.length - 1
                : 0;
        return donneesNotifications &&
            donneesNotifications.length > 0 &&
            donneesNotifications[lastIndex]
            ? donneesNotifications[lastIndex].id
            : 0;
    };

    const getApiNotifications = (dernierIdNotification) => {
        getApi(
            usagerClientReducer,
            `${API_GET_NOTIFICATIONS}?triDate=${getValues('TrierParDate')}&filtreTheme=${getValues(
                'FiltrerParTypeNotifications',
            )}&dernierIdNotification=${dernierIdNotification}`,
            CONTEXT_GET_NOTIFICATIONS,
        );
        // MAJ du nombre de notification après une suppression
        getApi(usagerClientReducer, API_GET_NOMBRE_NOTIFICATIONS, CONTEXT_GET_NOMBRE_NOTIFICATIONS);
    };

    // On mount
    // Revalider le tri date et le filtre thème et le nombre de notifs par page
    useEffect(() => {
        if (!isLoading) {
            getApiNotifications('0');
            setDonneesNotifications([]);
        }
    }, [watch('TrierParDate'), watch('FiltrerParTypeNotifications')]);

    useEffect(() => {
        if (dataNotifications) {
            reinitialiseApi(CONTEXT_GET_NOTIFICATIONS);
            if (Array.isArray(dataNotifications)) {
                setDonneesNotifications([...donneesNotifications, ...dataNotifications]);
            }
        }
    }, [dataNotifications]);

    const supprimerNotificationParId = (id) => {
        deleteApi(
            usagerClientReducer,
            `${API_DELETE_NOTIFICATION}${id}`,
            CONTEXT_DELETE_NOTIFICATION,
        );

        setDonneesNotifications(donneesNotifications.filter((notif) => notif.id !== id));

        // MAJ du nombre de notification après une suppression
        getApi(usagerClientReducer, API_GET_NOMBRE_NOTIFICATIONS, CONTEXT_GET_NOMBRE_NOTIFICATIONS);
    };

    const afficherPlusDeNotifications = () => {
        getApiNotifications(recupererDernierIdNotifications());
    };

    const supprimerToutesLesNotifications = () => {
        // supprimer un a un toutes les notifications affichées et supprimables avec leurs l'id
        deleteApi(
            usagerClientReducer,
            API_DELETE_ALL_NOTIFICATIONS,
            CONTEXT_DELETE_ALL_NOTIFICATIONS,
        );

        getApi(usagerClientReducer, API_GET_NOMBRE_NOTIFICATIONS, CONTEXT_GET_NOMBRE_NOTIFICATIONS);

        setDonneesNotifications([]);
        getApiNotifications('0');

        afficherPlusDeNotifications();
    };

    return (
        <div className="position-relative">
            {isLoading && <LoaderMi />}
            <h1>Notifications</h1>
            <Row goutierre>
                <Col col={6} xl={4}>
                    <div>Trier</div>
                </Col>
                <Col col={6} xl={4}>
                    <div>Filtre</div>
                </Col>
            </Row>
            <Row goutierre alignementVertical="bottom">
                <Col col={6} xl={4}>
                    <SelectMi
                        {...register('TrierParDate')}
                        name="TrierParDate"
                        placeholder="Trier par date"
                    >
                        {DATA_NOTIFICATION_SELECT_TRI_DATE.map((option) => (
                            <Option
                                key={option.key}
                                value={option.value}
                                disabled={option.disabled}
                                hidden={option.hidden}
                            >
                                {option.libelle}
                            </Option>
                        ))}
                    </SelectMi>
                </Col>
                <Col col={6} xl={4}>
                    <SelectMi
                        {...register('FiltrerParTypeNotifications')}
                        name="FiltrerParTypeNotifications"
                        placeholder="Filtrer par type"
                    >
                        {DATA_NOTIFICATION_SELECT_FILTRE.map((option) => (
                            <Option
                                key={option.key}
                                value={option.value}
                                disabled={option.disabled}
                                hidden={option.hidden}
                            >
                                {option.libelle}
                            </Option>
                        ))}
                    </SelectMi>
                </Col>
                <Col col={12} xl={4}>
                    <Bouton
                        type="submit"
                        label="Supprimer les notifications supprimables"
                        niveau="secondaire"
                        onClick={supprimerToutesLesNotifications}
                    />
                </Col>
            </Row>

            <br />

            {donneesNotifications && (
                <AfficherNotificationsDynamique
                    notifications={donneesNotifications}
                    supprimerNotificationParId={supprimerNotificationParId}
                />
            )}

            <div className="text-center margin-top-md">
                <Bouton
                    label="Afficher plus de notifications"
                    onClick={afficherPlusDeNotifications}
                    niveau="secondaire"
                />
            </div>
        </div>
    );
};

RechercherNotifications.propTypes = {
    getApi: PropTypes.func.isRequired,
    deleteApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataNotifications: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            description: PropTypes.string.isRequired,
            dateCreation: PropTypes.string.isRequired,
            themeNotification: PropTypes.string.isRequired,
            supprimable: PropTypes.bool.isRequired,
        }),
    ),
    isLoading: PropTypes.bool,
};

export default connect(
    (state) => {
        const { isLoading, data } = state.notification.notificationsUsager;
        return {
            dataNotifications: data,
            isLoading,
        };
    },
    {
        getApi: getAPI,
        deleteApi: deleteAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(RechercherNotifications);
